import React from 'react';
import {useFormik} from "formik";
import _ from "lodash";

const FormWrapper = ({editObject, handleSubmit, renderForm}) => {
    const formik = useFormik({
        initialValues: _.cloneDeep(editObject),
        onSubmit: (data) => handleSubmit(data)
    });

    return (
        <div className="form-wrapper">
            {renderForm(formik)}
        </div>
    );
}

export default FormWrapper;
